<template>
  <b-row class="px-1">
    <b-col class="feature-content" sm="12" md="4" xl="4" v-for="(item,index) in featureList" :key="index" @click="toFeatureDetial(item)">
      <div class="imgbox">
        <div class="img-cover">
        </div>
        <img :src="item.featureImgUrl" alt width="100%" />
        <div class="refer mr-1">
          <span class="feature-txt">{{item.numOfPosts}} Stories</span>
          <b-icon icon="arrow-right " class="arrow-right"></b-icon>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "FeatureContent",
  props:['featureList'],
  methods: {
    toFeatureDetial(item) {
      this.$router.push({
        path:'/featuredetail',
        query:{
          // 传featureId获取参数
          featureId:item.featureId
        }
      });
    }
  }
};
</script>

<style lang="less">
@media screen and (max-width: 768px) {
  .feature-content {
    padding: 0;
    .imgbox {
      width: 100%;
      color: #ffffff;
      position: relative;
      img {
        width: 100%;
      }
      .middle-txt {
        font-family: BodoniSvtyTwoITCTT-Book;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .refer {
        line-height: 0.3rem;
        cursor: pointer;
        position: absolute;
        font-family: OpenSans;
        right: 0;
        z-index: 100;
        // top: -40px;
        bottom: 10px;
        .feature-txt {
          font-size: 16px;
          margin-right: 5px;
        }
        .arrow-right {
          font-size: 16px;
        }
      }
    }
  }
}
@media screen and (min-width: 768px) {
  .feature-content {
    cursor: pointer;
    margin-top: 0.3rem;
    position: relative;
    .imgbox {
      width: 100%;
      height: 3rem;
      color: #ffffff;
      position: relative;
      .img-cover {
        height: 100%;
        width: 100%;
      }
      img {
        width: 100%;
        height: 100%;
      }

      .middle-txt {
        font-family: BodoniSvtyTwoITCTT-Book;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .refer {
        cursor: pointer;
        position: absolute;
        bottom: 0;
        right: 0;
        font-family: OpenSans;
        .feature-txt {
          font-size: 16px;
          margin-right: 5px;
        }
        .arrow-right {
          font-size: 16px;
        }
      }
    }
  }
}
</style>